import React, { useState, useEffect } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ALL_SURVEY_CATEGORIES } from "../../GraphQL/Queries";
import { CHANGE_STATE_CATEGORY_SURVEY } from "../../GraphQL/Mutations";
import MaterialTable from "material-table";
import {
  GeneralStyleSurveyCategory,
  ContentLoaderSurveyCategory,
  TableConvention,
  useStylesSurveyCategories,
} from "./SurveyCategories.styled";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import { Row, Col } from "react-bootstrap";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import PortalModal from "../../Portals";
import { NotificationManager } from "react-notifications";
import ModalConfirmAction from "../ModalConfirmAction/ModalConfirmAction";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import TablePagination from "@material-ui/core/TablePagination";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import NoRecord from "../NoRecord/NoRecord";
import { AntSwitch } from "../../helpers/antSwitch";
import { theme as themeConfig } from "../../themes/themes";
import moment from "moment";

const SurveyCategories = ({
  formTrigger,
  setFormTrigger,
  setupdateData,
  showCards,
  setShowCards,
  searchBy,
}) => {
  const classes = useStylesSurveyCategories();
  const [user] = useState(getStateLoginComplete());
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [showLoader, setshowLoader] = useState(false);
  const [reloadRender, setreloadRender] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [updateState] = useMutation(CHANGE_STATE_CATEGORY_SURVEY);
  const rowsPerPageList = [5, 10, 20];
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dataPaginated, setDataPaginated] = useState([]);
  const [categories, setCategories] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [columnSurveyCategories, setColumnSurveyCategories] = useState([]);
  const [runQuerySurveyCategories, { loading, error }] = useLazyQuery(
    ALL_SURVEY_CATEGORIES,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfAllSurveyCategories = data?.allCategoriesSurvey.outputData
          .map((o) => ({ ...o }))
          .filter((el) => el.recordState !== "Deleted" && el.categoryDescription !== "Global");

        setCategories(resultOfAllSurveyCategories);
        setOriginalList(resultOfAllSurveyCategories);
      },
    }
  );

  useEffect(() => {
    setColumnSurveyCategories([
      {
        title: "Survey ID",
        field: "idCategorySurvey",
        type: "string",
      },
      {
        title: "Description",
        field: "categoryDescription",
        type: "string",
      },
      {
        title: "Creation Date",
        type: "datetime",
        render: (rowData) => {
          return <>{moment(rowData?.createDate).format("YYYY-MM-DD")}</>;
        },
      },
      {
        title: "Created by",
        field: "createUser",
        type: "string",
      },
      {
        title: "Disable",
        field: "recordState",
        type: "string",
        cellStyle: {
          padding: "0px 16px",
        },
        render: (rowData) => {
          return (
            <FormControlLabel
              control={
                <AntSwitch
                  size="small"
                  checked={
                    rowData?.recordState.toUpperCase() === "ACTIVE"
                      ? true
                      : false
                  }
                  onChange={() => toggleChecked(rowData)}
                />
              }
            />
          );
        },
      },
      {
        title: "Action",
        field: "internal_action",
        sorting: false,
        cellStyle: {
          padding: "0px 16px",
        },
        render: (rowData) =>
          rowData && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Edit">
                  <IconButton
                    className={classes.active}
                    onClick={() => {
                      setAnchorEl(null);
                      setAnchorSelected(null);
                      setupdateData({ ...rowData });
                      setFormTrigger("survey");
                    }}
                  >
                    <EditTwoTone />
                  </IconButton>
                </Tooltip>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Delete">
                  <IconButton
                    className={classes.active}
                    disabled={rowData?.recordState.toUpperCase() === "ACTIVE"}
                    onClick={() => {
                      setOpenDeleteModal(rowData);
                    }}
                  >
                    <DeleteTwoTone />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          ),
      },
    ]);
  }, [categories]);

  useEffect(() => {
    if (searchBy === "") setCategories(originalList);
    else {
      const searchResult = originalList.filter((o) =>
        Object.keys(o).some((k) =>
          o[k].toString().toLowerCase().includes(searchBy.toLowerCase())
        )
      );
      setCategories(searchResult);
    }
  }, [searchBy]);

  useEffect(() => {
    if (searchBy === "") setCategories(originalList);
    else {
      const searchResult = originalList.filter((o) =>
        Object.keys(o).some((k) =>
          o[k].toString().toLowerCase().includes(searchBy.toLowerCase())
        )
      );
      setCategories(searchResult);
    }
  }, [searchBy]);

  useEffect(() => {
    runQuerySurveyCategories();
  }, [runQuerySurveyCategories, formTrigger]);

  useEffect(() => {
    let startIndex = rowsPerPage * currentPage;
    setDataPaginated(categories.slice(startIndex, startIndex + rowsPerPage));
  }, [rowsPerPage, categories, currentPage]);

  let updateCategoryFn = (rowData, state) => {
    setshowLoader(true);
    updateState({
      variables: {
        idCategorySurvey: rowData.idCategorySurvey,
        userChangeState: user.userName,
        newState: state,
      },
    }).then((response) => {
      setshowLoader(false);
      if (response.data.changeStateCategorySurvey.withError) {
        NotificationManager.warning(
          response.data.changeStateCategorySurvey.message
            ? response.data.changeStateCategorySurvey.message
            : "Error to update the category",
          "",
          5000
        );
      } else {
        if (state.toUpperCase() === "DELETED") {
          categories.splice(
            categories.findIndex(
              (f) => f.idCategorySurvey === rowData.idCategorySurvey
            ),
            1
          );
        } else {
          rowData.recordState = state;
          NotificationManager.success(
            "The state of the category is updated successfully ",
            "",
            5000
          );
        }
        setCategories([...categories]);
        setreloadRender(!reloadRender);
      }
    });
  };

  let toggleChecked = (rowData) => {
    updateCategoryFn(
      rowData,
      rowData.recordState.toUpperCase() === "ACTIVE" ? "INACTIVE" : "ACTIVE"
    );
  };

  let deleteSurvey = (rowData) => {
    updateCategoryFn(rowData, "DELETED");
    setOpenDeleteModal(null);
  };

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.idCategorySurvey);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this category?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteSurvey}
      />
    ) : null;
  };

  const tablePaginationListView = (props) => {
    const computedProps = { ...props };
    computedProps.style = {
      ...(computedProps?.style ?? {}),
      borderBottom: "0px",
    };
    return (
      <>
        <div style={{ display: "flex" }}>
          <div
            style={{
              display: "flex",
              width: "95%",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            {user && (
              <TableConvention>
                <div
                  style={{
                    background: "rgba(191, 191, 191, 1)",
                    height: "1em",
                    width: "1em",
                    borderRadius: "7px",
                  }}
                ></div>
                <p>Disable</p>
                <div
                  style={{
                    background: "rgba(4, 180, 105, 1)",
                    height: "1em",
                    width: "1em",
                    borderRadius: "7px",
                  }}
                ></div>
                <p>Active</p>
              </TableConvention>
            )}
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <table>
              <tbody>
                <tr>
                  <TablePagination {...computedProps} />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  return (
    <GeneralStyleSurveyCategory>
      {error && (
        <Row>
          <Col md="12" className="d-flex justify-content-center mt-5">
            {loading ? <PointersLine color={themeConfig.text.primary} /> : null}
            {error ? <h1>Error :(</h1> : null}
          </Col>
        </Row>
      )}

      {!loading && !showCards ? (
        <MaterialTable
          style={{ boxShadow: "none", marginLeft: "24px", marginRight: "20px" }}
          title=""
          columns={columnSurveyCategories}
          data={categories}
          options={{
            toolbar: false,
            search: false,
            maxBodyHeight: 450,
            headerStyle: {
              zIndex: 1,
              fontWeight: "bold",
            },
            cellStyle: {
              padding: "5px 10px",
            },
          }}
          components={{
            Pagination: tablePaginationListView,
          }}
        />
      ) : null}
      {showCards && (
        <>
          <ViewControlMenu
            identity={"survey-categories"}
            title={""}
            showCards={showCards}
            setShowCards={setShowCards}
            list={dataPaginated}
            toggleChecked={toggleChecked}
            handleClickActions={handleClickActions}
            anchorSelected={anchorSelected}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            setAnchorSelected={setAnchorSelected}
            setOpenDeleteModal={setOpenDeleteModal}
            setupdateData={setupdateData}
            triggerValue={"survey"}
            setFormTrigger={setFormTrigger}
            isAgent={false}
          />
          {categories.length === 0 ? <NoRecord /> : null}
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                width: "95%",
                justifyContent: "flex-start",
                alignItems: "center",
                marginLeft: "1.5rem",
              }}
            >
              {user && (
                <TableConvention>
                  <div
                    style={{
                      background: "rgba(191, 191, 191, 1)",
                      height: "1em",
                      width: "1em",
                      borderRadius: "7px",
                    }}
                  ></div>
                  <p>Disable</p>
                  <div
                    style={{
                      background: "rgba(4, 180, 105, 1)",
                      height: "1em",
                      width: "1em",
                      borderRadius: "7px",
                    }}
                  ></div>
                  <p>Active</p>
                </TableConvention>
              )}
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              {categories.length > 0 ? (
                <TablePagination
                  component="div"
                  style={{ display: "flex", justifyContent: "center" }}
                  count={categories.length}
                  page={currentPage}
                  onPageChange={(e, newPage) => {
                    setCurrentPage(newPage);
                  }}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={rowsPerPageList}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(
                      parseInt(
                        event?.target?.value ? event?.target?.value : "5"
                      )
                    );
                    setCurrentPage(0);
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      )}
      {showDeleteModal()}
      {(showLoader || loading) && (
        <PortalModal>
          <ContentLoaderSurveyCategory>
            <PointersLine color={themeConfig.text.primary}></PointersLine>
          </ContentLoaderSurveyCategory>
        </PortalModal>
      )}
    </GeneralStyleSurveyCategory>
  );
};
export default SurveyCategories;
